// extracted by mini-css-extract-plugin
module.exports = {"paymentInfo":"PaymentInfo_paymentInfo__QGv_I","info":"PaymentInfo_info__X7PJk"};